// extracted by mini-css-extract-plugin
export var dropdownButton = "_x-0";
export var fullWidthDropdownButton = "_x-1";
export var icon = "_x-3";
export var iconPlaceholder = "_x-2";
export var menuItemRow = "_x-9";
export var separator = "_x-e";
export var shortcutContainer = "_x-7";
export var shortcutContainerFilled = "_x-8";
export var shortcutIconLg = "_x-6";
export var shortcutIconMd = "_x-5";
export var shortcutIconSm = "_x-4";
export var submenuChevron = "_x-d";
export var submenuDropdown = "_x-a";
export var submenuTriggerRow = "_x-b";
export var submenuTriggerRowOpen = "_x-c";